import React, { useContext, useReducer, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "@material-ui/core/Button";
import MaterialTable from "material-table";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddBox";
import DataService from "../../../../../../Service";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import AddIconBox from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InternalExternalRate from "./internal_external_rate";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";
import { TooltipWrapper } from "../../../../../../Common/Utils/common_utils";
const useStyles = makeStyles((theme) => ({
  wrapper: {
    // padding:'5%'
  },
  tableWrapper: {
    padding: "5%",
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  paper: {
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    minHeight: "200px",
  },
  popoverBox: {
    boxShadow:
      "0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 2px 0px rgba(0,0,0,0.12)",
    pointerEvents: "auto",
    maxWidth: "200px",
  },
  detailWrap: {
    padding: "20px",
  },
  popover: {
    pointerEvents: "none",
  },
}));

export default function SimpleAction(props) {
  //
  const rateCard = useSelector((state) => state.commonReducer)?.accessPermission
    ?.assignmentDetail?.others?.rateCard;
  const globaluserData = useSelector((state) => state.commonReducer);

  const classes = useStyles();
  const { externalData, internalData } = props;
  const [externalSelection, setExternalSelection] = useState({});
  const [internalSelection, setInternalSelection] = useState({});
  const [moduleSetups, setModuleSetups] = useState([]);
  const [moduleSetups1, setModuleSetups1] = useState([]);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState({
    internal: false,
    external: false,
  });
  const role = globaluserData?.role || "";
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [openPopover, setPopover] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [status, setStatus] = useState("");

  const tableOptions = {
    search: true,
  };
  const columns = [
    { title: "Service", field: "service" },
    { title: "Level", field: "level" },
    { title: "Label", field: "label" },
    {
      title: "Program price",
      field: "programme_price",
      render: (rowData) => {
        return `${rowData.currency || ""} ${rowData.programme_price}`;
      },
    },
    { title: "Program hours", field: "programme_hours" },
    {
      title: "Session rate",
      field: "session_rate",
      render: (rowData) => {
        return `${rowData.currency || ""} ${rowData.session_rate}`;
      },
    },
    { title: "No of hrs in a session", field: "num_of_hours_in_a_session" },
    {
      title: "Hourly rate",
      field: "hourly_rate",
      render: (rowData) => {
        return `${rowData.currency || ""} ${rowData.hourly_rate}`;
      },
    },
  ];
  const columns1 = [
    { title: "Service", field: "service" },
    { title: "Label", field: "label" },
    { title: "Level", field: "level" },
    {
      title: "Program admin price",
      field: "programme_admin_price",
      render: (rowData) => {
        return `${rowData.currency || ""} ${rowData.programme_admin_price}`;
      },
    },
    { title: "No of sessions", field: "number_of_sessions" },
  ];

  useEffect(() => {
    ExternalCoaching();
    InternalCoaching();
    //props.setRefresh(true)
    // props.moduleSetup()
  }, [externalData, internalData]);

  const ExternalCoaching = () => {
    setModuleSetups(externalData);
  };
  const InternalCoaching = () => {
    setModuleSetups1(internalData);
  };
  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(moduleSetups);
      setModuleSetups(moduleList);
    } else if (data && data.id) {
      moduleList = moduleSetups.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModuleSetups(moduleList);
    } else if (!data && id) {
      moduleList = moduleSetups.filter((base) => base.id !== id);
      setModuleSetups(moduleList);
    }
    setAction(null);
    setExternalSelection({});
  };
  const handleClose1 = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(moduleSetups1);
      setModuleSetups1(moduleList);
    } else if (data && data.id) {
      moduleList = moduleSetups1.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModuleSetups1(moduleList);
    } else if (!data && id) {
      moduleList = moduleSetups1.filter((base) => base.id !== id);
      setModuleSetups1(moduleList);
    }
    setAction(null);
    setInternalSelection({});
    setInternalSelection({});
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setInternalSelection({});
  };

  const open = Boolean(anchorEl);

  const popOver = () => {
    return (
      <>
        <Typography
          aria-owns={open ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          key={Math.random() * 654898 + 1}
          onMouseOut={handlePopoverClose}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ChatBubbleIcon fontSize="small" />
        </Typography>
        <Popover
          id="mouse-over-popover"
          key={Math.random() * 2234598 + 1}
          className={classes.popover}
          classes={{
            paper: classes.popoverBox,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography style={{ margin: "5px" }}>
            {internalSelection.comments || ""}
          </Typography>
        </Popover>
      </>
    );
  };

  return (
    <div className={classes.wrapper}>
      {props.regionName !== undefined && (
        <React.Fragment>
          <Typography
            style={{ padding: "15px" }}
            variant="h1"
            color="secondary"
          >
            {" "}
            {props.regionName}
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={9}>
              <Typography
                style={{
                  padding: "15px",
                  color: "#4A4A4A",
                  fontWeight: "bold",
                }}
                variant="subtitle1"
                color="secondary"
              >
                {" "}
                External coaching rate card
              </Typography>
            </Grid>
            <Grid item xs={3}>
              {role !== "admin" ? (
                ""
              ) : (
                <Button
                  disableElevation
                  variant="contained"
                  style={{
                    fontSize: "14px",
                    marginLeft: "72px",
                    textTransform: "unset",
                  }}
                  color="secondary"
                  onClick={() => {
                    setExternalSelection({});
                    setInternalSelection({});
                    setAction("create");
                  }}
                  startIcon={<AddIconBox size="small" variant="outlined" />}
                >
                  New rate card
                </Button>
              )}
            </Grid>
          </Grid>
          <MaterialTable
            title=""
            style={{ marginTop: "20px" }}
            columns={columns}
            data={moduleSetups}
            isLoading={loading.external}
            options={{
              actionsColumnIndex: -1,
              search: false,

              pageSizeOptions: [20, 50, 75, 100],
              headerStyle: {
                position: "sticky",
                top: "0",
                fontWeight: "bold",
                padding: "13px",
              },
              maxBodyHeight: "600px",
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            totalCount={totalCount}
            onRowClick={(e, rowData) => {
              setExternalSelection(rowData);
            }}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            onSearchChange={(search) => {
              setSearchText(search);
            }}
            actions={
              !rateCard?.disableViewIcon && [
                // {
                //   icon: () => popOver(),
                //   onClick: (event, rowData) => {
                //     setInternalSelection(rowData);
                //   },
                // },
                {
                  icon: () => popOver(),
                  tooltip: <TooltipWrapper text="Comment" />,
                  onClick: (event, rowData) => {
                    setInternalSelection(rowData);
                    handlePopoverOpen(event);
                  },
                  // onMouseOut: (event, rowData) => {
                  //   setInternalSelection({});
                  //   // setAction("delete");
                  // },
                  // onMouseEnter: (event, rowData) => {
                  //   setInternalSelection(rowData);
                  //   // setAction("delete");
                  // },
                },

                {
                  icon: () => (
                    <EditIcon
                      key={Math.random() * 223898 + 1}
                      fontSize="small"
                    />
                  ),
                  tooltip: <TooltipWrapper text="Edit" />,
                  onClick: (event, rowData) => {
                    setAction("edit");
                    setStatus("external");
                    setExternalSelection(rowData);
                  },
                },
                {
                  icon: () => <DeleteIcon fontSize="small" />,
                  tooltip: <TooltipWrapper text="Delete" />,
                  onClick: (event, rowData) => {
                    setStatus("external");
                    setExternalSelection(rowData);
                    setAction("delete");
                  },
                },
              ]
            }
          />
          <div style={{ marginTop: "25px" }}></div>
          <Typography
            style={{
              fontWeight: "bold",
              padding: "15px",
              color: "#4A4A4A",
              marginTop: "30px",
            }}
            variant="subtitle1"
          >
            {" "}
            Internal coaching rate card
          </Typography>
          <MaterialTable
            title=""
            columns={columns1}
            data={moduleSetups1}
            isLoading={loading.internal}
            options={{
              actionsColumnIndex: -1,
              search: false,
              headerStyle: {
                fontWeight: "bold",
              },
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            totalCount={totalCount}
            onRowClick={(e, rowData) => {
              setInternalSelection(rowData);
            }}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            onSearchChange={(search) => {
              setSearchText(search);
            }}
            actions={
              !rateCard?.disableViewIcon && [
                {
                  icon: () => popOver(),
                  onClick: (event, rowData) => {
                    setInternalSelection(rowData);
                    handlePopoverOpen(event);
                  },
                  tooltip: <TooltipWrapper text="Comment" />,
                },
                {
                  icon: () => <EditIcon fontSize="small" />,
                  tooltip: <TooltipWrapper text="Edit" />,
                  onClick: (event, rowData) => {
                    setStatus("internal");
                    setInternalSelection(rowData);
                    setAction("edit1");
                  },
                },
                {
                  icon: () => <DeleteIcon fontSize="small" />,
                  tooltip: <TooltipWrapper text="Delete" />,
                  onClick: (event, rowData) => {
                    setStatus("internal");
                    setInternalSelection(rowData);
                    setAction("delete1");
                  },
                },
              ]
            }
          />
        </React.Fragment>
      )}
      {action && (
        <InternalExternalRate
          action={action}
          setRefresh={props.setRefresh}
          refresh={props.refresh}
          ExternalCoaching={ExternalCoaching}
          InternalCoaching={InternalCoaching}
          organisationId={props.organisationId}
          externalSelection={externalSelection}
          internalSelection={internalSelection}
          setLoading={props.setLoading}
          regionName={props.regionName}
          regionId={props.regionId}
          handleClose={handleClose}
          handleClose1={handleClose1}
          status={status}
          setInternalExternalLoader={setLoading}
        />
      )}
    </div>
  );
}
